import React from 'react';

import withStyles from '@mui/styles/withStyles';

// core components
import Card from '../md/components/Card/Card.jsx';
import CardBody from '../md/components/Card/CardBody.jsx';
import CardHeader from '../md/components/Card/CardHeader.jsx';

import userFormStyle from '../assets/jss/crm/views/userFormStyle';

import DA from '../store/ReduxAccess';

import { createStdRequest, apiFetch, validateAcceptablePassword, showAlert } from '../utils/utils';

import Modal from './Modal';
import ResetPasswordPanel from './ResetPasswordPanel';
import AlertModal from './AlertModal';

const localStyles = {
  ...userFormStyle,
  cardHeaderX: {
    marginBottom: '30px',
  },
  textCenter: {
    textAlign: 'center',
  },
  cardTitle: {
    fontSize: '1.3rem',
  },
};

class ResetPasswordModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      newPassword: '',
      confirmPassword: '',
    };
  }

  validationPolicy = {
    requirePassword: true,
    requirePasswordMatch: true,
  };

  changePassword(stateKey, newValue) {
    this.setState({ [stateKey]: newValue.trim() });
  }

  createApiStruct() {
    return { newPassword: this.state.newPassword };
  }

  validateForm() {
    if (this.validationPolicy.requirePassword) {
      if (!this.state.newPassword) {
        return {
          valid: false,
          errorMessage: 'You must supply a password',
        };
      }
      const passwordValidation = validateAcceptablePassword(this.state.newPassword);
      if (!passwordValidation.valid) {
        return passwordValidation;
      }
    }

    if (this.validationPolicy.requirePasswordMatch) {
      if (!this.state.confirmPassword) {
        return {
          valid: false,
          errorMessage: "You must enter your password again on the 'Confirm New Password' line",
        };
      }
      if (this.state.newPassword !== this.state.confirmPassword) {
        return {
          valid: false,
          errorMessage: "Your password confirmation doesn't match your password",
        };
      }
    }
    return { valid: true };
  }

  clearForm() {
    this.setState({
      newPassword: '',
      confirmPassword: '',
    });
  }

  acceptForm(userId) {
    const validation = this.validateForm();
    if (!validation.valid) {
      showAlert(this, validation.errorMessage);
      return;
    }
    const apiStruct = this.createApiStruct();
    const uri = `/api/user/${userId}/password`;
    const request = createStdRequest(uri, 'PUT', apiStruct);
    const actionOnGoodResponse = (json) => {
      const { success } = json;
      if (success) {
        this.clearForm();
        this.props.onSuccess();
      } else {
        showAlert(this, json.message);
      }
    };
    apiFetch(this.props.page, request, actionOnGoodResponse);
  }

  render() {
    const { classes, show, userId } = this.props;
    const userInfo = DA.getInfoForUser(userId);
    return (
      <div>
        <AlertModal show={this.state.shouldShowAlertModal} renderer={this} text={this.state.alertModalText} />

        <Modal
          open={show}
          okButtonLabel="Reset Password"
          cancelButtonLabel="Cancel"
          onOk={() => this.acceptForm(userId)}
          onCancel={() => this.props.onCancel()}
        >
          <Card login className={classes[this.state.cardAnimaton]}>
            <CardHeader className={classes.textCenter} color="allevaOrange" style={{ marginBottom: '20px' }}>
              <h4 className={classes.cardTitle}>User Profile</h4>
            </CardHeader>
            <CardBody>
              <ResetPasswordPanel
                userInfo={userInfo}
                newPassword={this.state.newPassword}
                confirmPassword={this.state.confirmPassword}
                onPasswordChange={(stateKey, newValue) => this.changePassword(stateKey, newValue)}
              />
            </CardBody>
          </Card>
        </Modal>
      </div>
    );
  }
}

export default withStyles(localStyles)(ResetPasswordModal);
